import React, { useState } from "react"

import * as S from "./food-cards.styles"
import { Grid } from "@mui/material"
import MenuItems from "../../components/menu-items/menu-items.component"
import Button from "@mui/material/Button"
import parse from "html-react-parser"
import Container from "@mui/material/Container"
import CustomButton from "../../components/custom-button/custom-button.component"

const FoodCards = ({ buttonLink, placeholderImage, menuItems }) => {
  const parse = require("html-react-parser")

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [title, setTitle] = useState("Appetizers")

  const handleMenuChange = (index, currentTitle) => {
    setSelectedIndex(index)
    setTitle(currentTitle)
  }

  return (
    <>
      <S.Background>
        <S.ButtonWrapperRight>
          {buttonLink && buttonLink.url && (
            <CustomButton
              href={buttonLink.url}
              target={buttonLink.target}
              className="red"
            >
              {buttonLink.title}
            </CustomButton>
          )}
        </S.ButtonWrapperRight>
        <S.Tabs container justify="center">
          <S.TabsContainer>
            {menuItems &&
              menuItems.length > 0 &&
              menuItems.map((item, index) => (
                <>
                  {item.titleMenu && (
                    <a
                      className={selectedIndex === index ? "active" : ""}
                      onClick={() => handleMenuChange(index, item.titleMenu)}
                      key={`menuItems-${index}`}
                    >
                      {item.titleMenu}
                    </a>
                  )}
                </>
              ))}
          </S.TabsContainer>
        </S.Tabs>
      </S.Background>
      <S.BackgroundMenu>
        <Container maxWidth="lg">
          <S.ButtonWrapperCenter>
            <CustomButton className="red">{title}</CustomButton>
          </S.ButtonWrapperCenter>
          <S.Columns container spacing={8}>
            {menuItems &&
              menuItems.length > 0 &&
              menuItems
                .slice(selectedIndex, selectedIndex + 1)
                .map(
                  items =>
                    items.items &&
                    items.items.length > 0 &&
                    items.items.map((item, index) => (
                      <MenuItems
                        item={item}
                        index={index}
                        image={placeholderImage}
                      />
                    ))
                )}
          </S.Columns>
          {menuItems &&
            menuItems.length > 0 &&
            menuItems
              .slice(selectedIndex, selectedIndex + 1)
              .map((item, index) => (
                <>
                  {item?.extraText && (
                    <S.Text key={`text-${index}`}>
                      {parse(item.extraText)}
                    </S.Text>
                  )}
                  <Grid container key={`grid-${index}`}>
                    {item?.grid?.left && (
                      <Grid item xs={12} sm={6}>
                        {parse(item.grid.left)}
                      </Grid>
                    )}
                    {item?.grid?.right && (
                      <Grid item xs={12} sm={6}>
                        {parse(item.grid.right)}
                      </Grid>
                    )}
                  </Grid>
                </>
              ))}
        </Container>
      </S.BackgroundMenu>
    </>
  )
}

export default FoodCards
